function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_metro-filter",
  "data-name": "Icon metro-filter",
  d: "M14.571,1.928c-6.627,0-12,1.679-12,3.75v2.25l9,9v7.5c0,.828,1.343,1.5,3,1.5s3-.672,3-1.5v-7.5l9-9V5.678C26.571,3.607,21.2,1.928,14.571,1.928ZM4.783,5.182A10.207,10.207,0,0,1,7.063,4.3a29.584,29.584,0,0,1,7.508-.875,29.584,29.584,0,0,1,7.508.875,10.209,10.209,0,0,1,2.28.879,2.609,2.609,0,0,1,.663.5,2.611,2.611,0,0,1-.663.5,10.209,10.209,0,0,1-2.28.879,29.583,29.583,0,0,1-7.508.875,29.583,29.583,0,0,1-7.508-.875,10.207,10.207,0,0,1-2.28-.879,2.612,2.612,0,0,1-.663-.5A2.612,2.612,0,0,1,4.783,5.182Z",
  transform: "translate(-2.571 -1.928)",
  fill: "#3be3f9"
});

var SvgFilterIcon = function SvgFilterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter-icon.2cb03fe5.svg";
export { ForwardRef as ReactComponent };